import React, { Fragment, useReducer, useState, useEffect, useRef } from 'react'

import PageSwiper from 'components/PageSwiper'
import H5Components from 'h5-components'
import 'assets/style/index.scss'
import { AppContext } from '@/Context'
import CustomInput from 'components/common/input'
import { contextReducer } from '@/common/store/reducer'
import initialState from '@/common/store'
import { initTempData } from '@/common/store/action.js'

import { getDetail, report, pvuv } from '@/utils/biz-api.js'
import { guid } from '@/utils'
import Notifications, { notify } from 'react-notify-toast'

import Loadable from 'react-loadable'
const Report = Loadable({
  loader: () => import('h5-report'),
  loading() {
    return <div></div>
  },
})
function App(props) {
  //第二个参数为state的初始状态
  const [state, dispatch] = useReducer(contextReducer, { pages: [] })
  // const [pageRenderer, setPageRenderer] = useState(
  //   !!window.JsBridge.isInXfpyApp && !window.works_id ? "loaded" : "loading"
  // );
  const [pageRenderer, setPageRenderer] = useState('loading')
  const inApps = window.JsBridge.isInXfpyApp
  const [errorTip, setErrorTip] = useState('详情获取失败，请稍后再试')
  const noBrand = state.noBrand
  const tempMode = state.tempMode
  const bgAudio = state.globalData && state.globalData.bg.src
  const bgAudioReplaced = state.globalData && state.globalData.bg.replaced
  const reportRef = useRef()
  const errorCall = (e) => {
    inApps
      ? window.JsBridge.xfpyappJsBridge.toast('背景音播放失败')
      : notify.show('背景音播放失败')
  }
  const queryWork = (works_id) => {
    if (!works_id) {
      setPageRenderer('error')
      return Promise.reject('invalid works_id')
    }
    return new Promise((resolve, reject) => {
      let ciinfo = null
      if (inApps) {
        let baseInfo = window.JsBridge.xfpyappJsBridge.getClientBaseInfo('{}')
        console.log(`客户端返回数据`, typeof baseInfo, baseInfo)
        try {
          if (baseInfo) {
            baseInfo = JSON.parse(baseInfo)
            ciinfo = baseInfo.ci || null
          }
        } catch (e) {
          console.error(`解析客户端返回数据失败，`, e)
          ciinfo = null
        }
      }
      // 异步获取数据
      getDetail({
        works_id: works_id,
        type: inApps ? 0 : 1,
        f: window.wf || '',
        uid: (ciinfo && ciinfo.usid) || '',
      })
        .then((resp) => {
          console.log('request detail:', resp)
          if (resp.h5_works_info && resp.h5_works_info.works_name) {
            document.title = resp.h5_works_info.works_name
          }
          // 触发加载数据
          let workData = null
          if (
            resp.h5_works_info &&
            (((resp.h5_works_info.status_at === 1 ||
              resp.h5_works_info.status_at === 2) &&
              !inApps) ||
              (inApps && resp.h5_works_info.status_at !== 3))
          ) {
            try {
              workData = resp.h5_works_info.works_data
                ? JSON.parse(resp.h5_works_info.works_data)
                : null
            } catch (e) {
              console.error(e)
              workData = null
            }
          }
          if (!workData) {
            console.error(
              'invalid work , [status]:: ',
              resp.h5_works_info && resp.h5_works_info.status_at
            )
            return Promise.reject(resp.h5_works_info)
          }
          let initialState = {
            ...workData,
            noBrand: !!resp.h5_works_info.del_end_page,
            // 直接是预览模式
            tempMode: 'view',
          }
          initialState.globalData = initialState.globalData || {
            bg: {},
          }
          initialState.globalData.bg.src =
            initialState.globalData.bg.src || resp.h5_works_info.audio_url

          window.xfpyh5.loadTemplate(0, initialState, '{}')
          setTimeout(() => {
            // http://172.31.4.34/stat.gif?id=123&uid=1234
            setPageRenderer('loaded')
          })
        })
        .catch((e) => {
          setPageRenderer('error')
          console.error('request error', e)
          if (e && e.status_at !== undefined) {
            showErrorTip(e.status_at)
          } else {
            showErrorTip(999999)
          }
        })
    })
  }
  const showErrorTip = (status) => {
    let tip = '作品详情异常'
    // 0审核不通过 1审核通过 2支付成功待审核  3-用户自己下线 4-举报下线待审核 5-作品已删除
    switch (status) {
      case 0:
        tip = '该页面包含违规内容，已停止访问，无法查看'
        break
      case 1:
        tip = ''
        break
      case 2:
        tip = '该页面被多人举报，已停止访问，后台审核中'
        break
      case 3:
        tip = '你访问的页面走丢了……'
        break
      case 4:
        tip = '该页面被多人举报，已停止访问，后台审核中'
        break
      case 5:
        tip = '你访问的页面走丢了……'
        break
      case 999999:
        tip = '详情获取失败，请稍后再试'
        break
      default:
        tip = '无效的作品详情'
        break
    }
    setErrorTip(tip)
  }
  const bgNativePlay = () => {
    console.info('resumeBgm')
    window.JsBridge.xfpyappJsBridge.resumeBgm()
  }
  const bgNativePause = () => {
    console.info('pauseBgm')
    window.JsBridge.xfpyappJsBridge.pauseBgm()
  }
  const reportValid = (err) => {
    notify.show(err)
  }
  const reportInfo = (rptInfo) => {
    console.log(rptInfo)
    if (
      localStorage.getItem(window.h5uid + window.works_id + '_' + rptInfo.type)
    ) {
      return notify.show('已收到您的投诉举报')
    }
    if (rptInfo.type === 6 && !rptInfo.remark) {
      return notify.show('请填写举报描述')
    }
    report({
      works_id: window.works_id,
      feed_type: rptInfo.type,
      remark: rptInfo.remark,
    })
      .then((resp) => {
        refreshUid()
        localStorage.setItem(
          window.h5uid + window.works_id + '_' + rptInfo.type,
          true
        )
        reportRef.current.hidden()
        notify.show('举报成功')
      })
      .catch((e) => {
        notify.show('举报失败，请稍后再试')
      })
  }
  const refreshUid = () => {
    window.h5uid = localStorage.getItem('xfpy_h5_uid')
    if (!window.h5uid) {
      window.h5uid = guid()
      localStorage.setItem('xfpy_h5_uid', window.h5uid)
    }
  }
  useEffect(() => {
    console.warn('JsBridge', window.JsBridge)
    refreshUid()
    // todo pv & uv
    if (!inApps) {
      pvuv({
        uid: window.h5uid,
        id: window.works_id,
      })
    }
  }, [inApps])

  useEffect(() => {
    window.JsBridge.xfpyappH5Js.off('previewDiy')
    window.JsBridge.xfpyappH5Js.on('previewDiy', (audioUrl, ex) => {
      let workJson = JSON.parse(JSON.stringify(state))
      console.log('native call previewDiy,workJson:', workJson)
      if (audioUrl) {
        workJson.globalData.bg.replaced = true
        workJson.globalData.bg.src =
          audioUrl || workJson.globalData.bg.src || ''
      } else {
        workJson.globalData.bg.replaced = false
      }
      console.info('previewDiyComplete', workJson)
      window.JsBridge.xfpyappJsBridge.previewDiyComplete(
        JSON.stringify(workJson),
        '{}'
      )
    })
  })
  useEffect(() => {
    window.JsBridge.xfpyappH5Js.on('loadTemplate', (mode, data, ex) => {
      // 触发加载数据
      setTimeout(() => {
        setPageRenderer('loaded')
      })
      console.log('native call loadTemplate:', mode, data, ex)
      switch (mode) {
        case 0:
        case '0':
          // console.log("initialState", data);
          try {
            data = data ? JSON.parse(data) : initialState
          } catch (e) {}
          dispatch(initTempData({ ...data, tempMode: 'view' }))
          // dispatch(switchNoPageBrand(false));
          break
        case 1:
        case '1':
          window.edit_mode = true
          window.setRem()
          dispatch(initTempData({ ...initialState, tempMode: 'edit' }))
          break
        case 2:
        case '2':
          try {
            data = (data || '').replace(/[\r]/g, '\\r').replace(/[\n]/g, '\\n')
            console.log(`创作预览data::`, data)
            data = data ? JSON.parse(data) : initialState
          } catch (e) {
            console.error('解析失败', e)
            data = initialState
          }
          dispatch(initTempData({ ...data, tempMode: 'preview' }))
          break
      }
    })

    window.JsBridge.xfpyappJsBridge.pageReady()
    /**有作品id 或者不在app内部 均直接自己获取数据*/

    // window.xfpyh5.loadTemplate(0, null, "{}");

    if (!window.JsBridge.isInXfpyApp || window.works_id) {
      queryWork(window.works_id)
    }
    // TODO 模拟数据
    // else {
    //   window.xfpyh5.loadTemplate(1, null, "{}");
    // }
    return () => {
      window.JsBridge.xfpyappH5Js.off('loadTemplate')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <Fragment>
      <AppContext.Provider value={{ state, dispatch: dispatch }}>
        <H5Components.Loading
          shown={pageRenderer === 'loading'}
          text="加载中..."
        ></H5Components.Loading>
        {pageRenderer === 'loaded' && tempMode !== 'edit' && (
          <H5Components.SpinGlobalAudio
            className={
              tempMode === 'edit'
                ? 'spin-global-audio edit-mode'
                : 'spin-global-audio'
            }
            fadeAudio={
              window.JsBridge.isInXfpyApp &&
              tempMode !== 'view' &&
              bgAudioReplaced
            }
            loop={true}
            nativePlay={bgNativePlay}
            nativePause={bgNativePause}
            autoPlay={tempMode === 'edit' ? false : true}
            canPlay={tempMode === 'edit' ? false : true}
            src={bgAudio}
            errorCall={errorCall}
          ></H5Components.SpinGlobalAudio>
        )}
        {pageRenderer === 'loaded' && (
          <PageSwiper
            pageRenderer={pageRenderer}
            loop={props.nbrd}
            noBrand={noBrand}
            swiperNextOnEnd={() => {}}
          ></PageSwiper>
        )}
        {pageRenderer === 'error' && <div className="page-tip">{errorTip}</div>}
        {pageRenderer === 'loaded' && !inApps && (
          <Report cRef={reportRef} error={reportValid} report={reportInfo} />
        )}
        {tempMode === 'edit' && <CustomInput />}
      </AppContext.Provider>
      <Notifications options={{ timeout: 1500 }} />
      {/* <div className="input-page"></div> */}
    </Fragment>
  )
}

export default App
